module.exports = "/next-static/_next/static/images/block_image_guest_interviews-30740848663cbf065e0edea30045a171.png";